import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { AppService } from "../../app.service";
import { UTILITIES } from "../../core/utility/utilities";

import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
// import { LaunchReview } from '@ionic-native/launch-review/ngx';

@Component({
  selector: 'app-rating-popup',
  templateUrl: './rating-popup.component.html',
  styleUrls: ['./rating-popup.component.scss'],
})
export class RatingPopupComponent implements OnInit {

  page: number = 1;
  comments: string = "";
  rate: number;
  @ViewChild('rating') rating: any;
  isIOS = this.utilities.isDeviceiOS();

  constructor(
    public modalController: ModalController,
    private appService: AppService,
    private utilities: UTILITIES,
    private iab: InAppBrowser,
    // private launchReview: LaunchReview
  ) { }

  ngOnInit() { }

  onRateChange(rating) {
    if (rating < 1) return  true;
    setTimeout(() => this.rate = rating, 0)
  }

  ionViewWillEnter(){
    this.utilities.logEvent("rating_view",{});
    this.rate = localStorage.getItem("rating") ? Number(localStorage.getItem("rating")) : 0;
  }

  onRate() {
    if (this.rate <= 3) this.page = 2;
    else this.submitRating();
  }

  onSubmit() {
    this.submitRating();
  }

  continue() {
    this.page++;
  }

  closeRateusPopup() {
    this.page = 1;
    this.modalController.dismiss();
  }

  onRateusOnStore() {
    
    if (this.utilities.isDeviceiOS()){
      this.utilities.logEvent("rating_view_redirect_to_applestore",{});
      this.iab.create("https://apps.apple.com/us/app/smartdiet-planner-weight-loss/id1545821590", "_system", "location=yes");
    } 
    else {
      this.utilities.logEvent("rating_view_redirect_to_playstore",{});
      this.iab.create("https://play.google.com/store/apps/details?id=com.diet.planner", "_system", "location=yes");
    }
  }

  submitRating() {
    this.utilities.logEvent("rating_submit",{});
    let self = this;
    let reqBody = {
      "rating": this.rate,
      "reviewDetail": this.comments
    }
    this.appService.postRatings(reqBody).then(
      res => {
        localStorage.setItem("rating",this.rate.toString());
        if (self.rate > 3) self.page = 4;
        else self.page = 3;
      }, err => {
        
      });
  }

}
